import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { ConfigProvider, theme } from 'antd';
import AlertTemplate from 'react-alert-template-basic';
import { Provider as AlertProvider } from 'react-alert';

import store, { history } from './store';
import 'maplibre-gl/dist/maplibre-gl.css';
import './index.less';
import Routes from './routes';
import reportWebVitals from './reportWebVitals';
import NotifService from './NotifService';
import { disablePageZoom } from './helpers/pageZoom';

// Before the first render: a pinch belongs to the map, never to the page.
disablePageZoom();

const darkPrimary = '#0088FF';
const colorPrimary = '#0088FF';
const colorLink = '#0088FF';
const colorWhite = '#FFFFFF';
const colorStrokeField = '#D9D9D9';
const themeDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

const themeConfig = {
	token: {
		colorPrimary,
		colorLink,
		colorPrimaryHover: colorPrimary,

		// Custom Colors
		colorDarkPrimary: darkPrimary,
		colorWhite,
		colorStrokeField
	},
	components: {
		Layout: {
			siderBg: themeDark ? '#2C2F36' : '#FFFFFF'
		},
		Menu: {
			darkItemSelectedBg: colorLink,
			itemHeight: 58
		},
		Button: {
			primaryShadow: null,
			algorithm: true,
			colorPrimary,
			buttonBgColor: themeDark ? '#2C2F36' : '#FFFFFF'
		},
		FloatButton: {
			primaryShadow: null,
			algorithm: true
		},
		Radio: {
			primaryShadow: null,
			algorithm: true,
			colorPrimary,
			buttonBgColor: themeDark ? '#2C2F36' : '#D9D9D9'
		},
		Checkbox: {
			colorBgContainer: themeDark ? '#2c3036' : '#FFFFFF',
			buttonBgColor: themeDark ? '#2C2F36' : '#D9D9D9'
		},
		Input: {
			activeShadow: null,
			algorithm: true,
			colorPrimary
		},
		Modal: {
			titleColor: darkPrimary,
			headerBg: colorWhite
		},
		Segmented: {
			itemActiveBg: colorPrimary,
			itemColor: themeDark ? '#FFFFFF' : '#2c3036',
			itemSelectedBg: colorPrimary,
			itemSelectedColor: themeDark ? '#2c3036' : '#FFFFFF',
			trackBg: themeDark ? '#2c3036' : '#FFFFFF'
		}
	},
	algorithm: themeDark
		? theme.darkAlgorithm :
		theme.defaultAlgorithm
};

const alertOptions = {
	position: 'bottom right',
	timeout: 5000,
	offset: '30px',
	transition: 'scale',
	containerStyle: {
		zIndex: 1001
	}
};

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store()}>
			<AlertProvider
				template={AlertTemplate}
				{...alertOptions}
			>
				<NotifService>
					<ConnectedRouter history={history}>
						<ConfigProvider theme={themeConfig}>
							<Routes />
						</ConfigProvider>
					</ConnectedRouter>
				</NotifService>
			</AlertProvider>
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
